import { PageLoadingState } from '@wanjianshi/admin-ui';
import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '@/auth/store';

export function AuthGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const status = useAdminAuth(state => state.status);
  const bootstrap = useAdminAuth(state => state.bootstrap);
  useEffect(() => {
    if (status === 'booting') void bootstrap();
  }, [bootstrap, status]);
  if (status === 'booting') return <div className="centered-state"><PageLoadingState /></div>;
  if (status === 'anonymous') return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}
